module.exports = __webpack_public_path__ + "static/media/chameleon-consumer-header-horizontal.575fb7d3.png";